import { Menu } from "@ofrz/ui-package";
import { MenuItem } from "@ofrz/ui-package/dist/components/MenuItem/types";
import { CROSSPAY_ROUTES } from "libs/routes";
import { connect } from "react-redux";
import { useLocation } from "react-router";
import { HomeIcon, MerchantIcon, ProductIcon } from "static/images/svgs";
import { CrosspayLogo } from "static/images/svgs/crosspay-logo";

import { RolesTypes } from "libs/models/login";
import { CheckBalanceIcon } from "static/images/svgs/check-balance-icon-svg";
import { ContactsSvg } from "static/images/svgs/contacts-svg";
import { LogoutSvg } from "static/images/svgs/logout-svg";
import { PosIcon } from "static/images/svgs/nav-bar/pos-icon";
import { SettingIcon } from "static/images/svgs/setting-icon-svg";
import { UsersSvg } from "static/images/svgs/users-svg";
import { CustomizedPush } from "store/navigation-wrapper";
import { logout } from "store/slices/logout";
import { AppDispatch, ApplicationState } from "../../store";
import translate from "../../utils/translations";
import { SideNavigationBarProps } from "./side-navigation-bar.props";

const SideNavigationBar = (props: SideNavigationBarProps) => {
  const location = useLocation();

  const isActiveButton = (buttonRoute: string) => {
    return location.pathname == buttonRoute;
  };

  const onButtonClicked = (buttonRouteClicked: string) => {
    if (buttonRouteClicked === "logout") {
      props.logout();
    } else {
      props.goTo(buttonRouteClicked);
    }
  };
  var sideBarItems: MenuItem[] = [
    {
      id: CROSSPAY_ROUTES.DASHBOARD,
      hide: props.roleType !== RolesTypes.SuperAdmin,
      title: (
        <>
          <HomeIcon active={isActiveButton(CROSSPAY_ROUTES.DASHBOARD)} /> &nbsp;
          {`${translate("Dashboard_Text", "Dashboard TODO")}`}
        </>
      ),
      isActive: isActiveButton(CROSSPAY_ROUTES.DASHBOARD),
    },
    {
      id: CROSSPAY_ROUTES.CLIENT_VIEW,
      hide: props.roleType !== RolesTypes.SuperAdmin,
      title: (
        <>
          <UsersSvg active={isActiveButton(CROSSPAY_ROUTES.CLIENT_VIEW)} />
          &nbsp;
          {`${translate("Clients_Text", "Clients")}`}
        </>
      ),
      isActive: isActiveButton(CROSSPAY_ROUTES.CLIENT_VIEW),
    },
    {
      id: CROSSPAY_ROUTES.CARD_OPERATIONS,
      hide: props.roleType !== RolesTypes.POSUser,
      title: (
        <>
          <UsersSvg active={isActiveButton(CROSSPAY_ROUTES.CARD_OPERATIONS)} />
          &nbsp;
          {`${translate("Card_Operations_Text", "Card operations TODO")}`}
        </>
      ),
      isActive: isActiveButton(CROSSPAY_ROUTES.CLIENT_VIEW),
    },
    {
      id: CROSSPAY_ROUTES.REDEMPTION_CHANNEL,
      hide: props.roleType === RolesTypes.POSUser,
      title: (
        <>
          <MerchantIcon
            active={isActiveButton(CROSSPAY_ROUTES.REDEMPTION_CHANNEL)}
          />{" "}
          &nbsp;
          {`${translate("Branches_Text", "Branches TODO")}`}
        </>
      ),
      isActive: isActiveButton(CROSSPAY_ROUTES.REDEMPTION_CHANNEL),
    },
    {
      id: CROSSPAY_ROUTES.POINT_OF_SALE,
      hide: props.roleType === RolesTypes.POSUser,
      title: (
        <>
          <PosIcon active={isActiveButton(CROSSPAY_ROUTES.POINT_OF_SALE)} />{" "}
          &nbsp;
          {`${translate("Point_Of_Sale_Text", "Point Of Sale TODO")}`}
        </>
      ),
      isActive: isActiveButton(CROSSPAY_ROUTES.POINT_OF_SALE),
    },
    {
      id: CROSSPAY_ROUTES.USER_VIEW,
      hide: props.roleType === RolesTypes.POSUser,
      title: (
        <>
          <ContactsSvg active={isActiveButton(CROSSPAY_ROUTES.USER_VIEW)} />{" "}
          &nbsp;
          {`${translate("Client_Account_Text", "Client Accounts")}`}
        </>
      ),
      isActive: isActiveButton(CROSSPAY_ROUTES.USER_VIEW),
    },
    {
      id: CROSSPAY_ROUTES.PRODUCT,
      hide: props.roleType === RolesTypes.POSUser,
      title: (
        <>
          <ProductIcon active={isActiveButton(CROSSPAY_ROUTES.PRODUCT)} />{" "}
          &nbsp;
          {`${translate("Products_Text", "Products")}`}
        </>
      ),
      isActive: isActiveButton(CROSSPAY_ROUTES.PRODUCT),
    },
    {
      id: CROSSPAY_ROUTES.CHECK_BALANCE,
      hide: props.roleType === RolesTypes.POSUser,
      title: (
        <>
          <CheckBalanceIcon
            active={isActiveButton(CROSSPAY_ROUTES.CHECK_BALANCE)}
          />
          &nbsp;
          {`${translate("Check_Balance_Text", "CHECK_BALANCE")}`}
        </>
      ),
      isActive: isActiveButton(CROSSPAY_ROUTES.CHECK_BALANCE),
    },
    // {
    //   title: (
    //     <>
    //       <ReportIcon
    //         active={
    //           isActiveButton(CROSSPAY_ROUTES.REPORT_SALES) ||
    //           isActiveButton(CROSSPAY_ROUTES.REPORT_REDEMPTION) ||
    //           isActiveButton(CROSSPAY_ROUTES.REPORT_PRODUCT_INVENTORY) ||
    //           isActiveButton(CROSSPAY_ROUTES.REPORT_INVOICING) ||
    //           isActiveButton(CROSSPAY_ROUTES.REPORT_CUSTOMER_BEHAVIOUR) ||
    //           isActiveButton(CROSSPAY_ROUTES.REPORT_TRANSACTION)
    //         }
    //       />{" "}
    //       &nbsp;
    //       {`${translate("Reports_Text", "Reports")}`}
    //     </>
    //   ),
    //   hide: props.roleType === RolesTypes.POSUser,
    //   isActive:
    //     isActiveButton(CROSSPAY_ROUTES.REPORT_SALES) ||
    //     isActiveButton(CROSSPAY_ROUTES.REPORT_REDEMPTION) ||
    //     isActiveButton(CROSSPAY_ROUTES.REPORT_PRODUCT_INVENTORY) ||
    //     isActiveButton(CROSSPAY_ROUTES.REPORT_INVOICING) ||
    //     isActiveButton(CROSSPAY_ROUTES.REPORT_CUSTOMER_BEHAVIOUR) ||
    //     isActiveButton(CROSSPAY_ROUTES.REPORT_TRANSACTION),

    //   subItems: [
    //     {
    //       id: CROSSPAY_ROUTES.REPORT_SALES,
    //       title: (
    //         <>
    //           {`${translate("Sales_Report_Text", "Sales Report")}`}
    //           &nbsp;
    //         </>
    //       ),
    //       isActive: isActiveButton(CROSSPAY_ROUTES.REPORT_SALES),
    //     },
    //     // {
    //     //   id: CROSSPAY_ROUTES.REPORT_REDEMPTION,
    //     //   title: (
    //     //     <>{`${translate("Redemption_Report_Text", "Redemption Report")}`}</>
    //     //   ),
    //     //   isActive: isActiveButton(CROSSPAY_ROUTES.REPORT_REDEMPTION),
    //     // },
    //     {
    //       id: CROSSPAY_ROUTES.REPORT_PRODUCT_INVENTORY,
    //       title: (
    //         <>{`${translate("Product_Inventory_Text", "Product Inventory")}`}</>
    //       ),
    //       isActive: isActiveButton(CROSSPAY_ROUTES.REPORT_PRODUCT_INVENTORY),
    //     },
    //     // {
    //     //   id: CROSSPAY_ROUTES.REPORT_INVOICING,
    //     //   title: <>{`${translate("Invoicing_Text", "Invoicing")}`}</>,
    //     //   isActive: isActiveButton(CROSSPAY_ROUTES.REPORT_INVOICING),
    //     // },
    //     {
    //       id: CROSSPAY_ROUTES.REPORT_TRANSACTION,
    //       title: (
    //         <>{`${translate(
    //           "Transaction_Reports_Text",
    //           "Transaction Reports",
    //         )}`}</>
    //       ),
    //       isActive: isActiveButton(CROSSPAY_ROUTES.REPORT_TRANSACTION),
    //     },
    //   ],
    // },
  ];

  return (
    <div className="flex-col w-full h-full p-5">
      <div className="flex align-middle items-center px-4">
        <CrosspayLogo />
      </div>
      <div className={`flex flex-col h-3/4`}>
        <Menu
          items={sideBarItems}
          isExpandable={false}
          onClick={onButtonClicked}
        />
      </div>
      <div className={`flex flex-col h-1/4`}>
        <Menu
          items={[
            {
              id: "settings",
              title: (
                <div className="mt-auto flex flex-row items-start space-y-10 text-gray-500">
                  <SettingIcon /> &nbsp;
                  {`${translate("Settings_Text", "Settings")}`}
                </div>
              ),
            },
            {
              id: "logout",
              title: (
                <div className="mt-auto flex flex-row items-start space-y-10 text-[#B23B3B]">
                  <LogoutSvg /> &nbsp;
                  {`${translate("Logout_Text", "Logout")}`}
                </div>
              ),
            },
          ]}
          isExpandable={false}
          onClick={onButtonClicked}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state: ApplicationState) => ({
  roleType: state.login.userRole!,
  locale: state.ui.locale,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  goTo: (route: string) => {
    CustomizedPush(route);
  },
  logout: () => {
    dispatch(logout());
  },
});

export const SideNavigationBarContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SideNavigationBar);
